// Remembered Payroll Workbench view (page, search, range, expanded workers) — per user, per browser.
const key = (userId) => `ht_payroll_view_${userId || 'anon'}`;

export const loadPayrollView = (userId) => {
  try { return JSON.parse(localStorage.getItem(key(userId)) || 'null') || {}; } catch { return {}; }
};

export const savePayrollView = (userId, patch) => {
  try {
    const cur = loadPayrollView(userId);
    localStorage.setItem(key(userId), JSON.stringify({ ...cur, ...patch, saved_at: Date.now() }));
  } catch { /* ignore */ }
};

export const clearPayrollView = (userId) => {
  try { localStorage.removeItem(key(userId)); } catch { /* ignore */ }
};
